import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { ServicesComponent } from './pages/services/services.component';
import { FaqComponent } from './pages/faq/faq.component';
import { ContactComponent } from './pages/contact/contact.component';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {HttpModule} from "@angular/http";
import {HttpClientModule} from "@angular/common/http";
import {RouterModule} from "@angular/router";
import {routerConfig} from "./pages/router.config";
import { HeaderComponent } from './header/header.component';
import {GalleriaModule} from 'primeng/primeng';
import { SlideGalleryComponent } from './widget/slide-gallery/slide-gallery.component';
import {CommonModule} from "@angular/common";
import { WideBannerComponent } from './widget/wide-banner/wide-banner.component';
import { FooterComponent } from './footer/footer.component';
import { SalvageYardManagementComponent } from './pages/services/salvage-yard-management/salvage-yard-management.component';
import { SupplyAndDeliveryComponent } from './pages/services/supply-and-delivery/supply-and-delivery.component';
import { WasteCollectionComponent } from './pages/services/waste-collection/waste-collection.component';
import { PlantHireComponent } from './pages/services/plant-hire/plant-hire.component';
import { CleaningServiceComponent } from './pages/services/cleaning-service/cleaning-service.component';
import { IllegalDumpsComponent } from './pages/services/illegal-dumps/illegal-dumps.component';
import { WhoAreWeComponent } from './pages/about/who-are-we/who-are-we.component';
import { WhatWeDoComponent } from './pages/about/what-we-do/what-we-do.component';
import { SellingPointComponent } from './pages/about/selling-point/selling-point.component';
import { AboutComponent } from './pages/about/about/about.component';
import { BackgroundComponent } from './pages/company/background/background.component';
import { VisionComponent } from './pages/company/vision/vision.component';
import { MissionComponent } from './pages/company/mission/mission.component';
import { ObjectivesComponent } from './pages/company/objectives/objectives.component';
import { ValuesComponent } from './pages/company/values/values.component';
import { CompanyComponent } from './pages/company/company/company.component';
import { ClientStripComponent } from './widget/client-strip/client-strip.component';
import { ProductsComponent } from './pages/products/products.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ServicesComponent,
    FaqComponent,
    ContactComponent,
    HeaderComponent,
    SlideGalleryComponent,
    WideBannerComponent,
    FooterComponent,
    SalvageYardManagementComponent,
    SupplyAndDeliveryComponent,
    WasteCollectionComponent,
    PlantHireComponent,
    CleaningServiceComponent,
    IllegalDumpsComponent,
    WhoAreWeComponent,
    WhatWeDoComponent,
    SellingPointComponent,
    AboutComponent,
    BackgroundComponent,
    VisionComponent,
    MissionComponent,
    ObjectivesComponent,
    ValuesComponent,
    CompanyComponent,
    ClientStripComponent,
    ProductsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    HttpModule,
    HttpClientModule,
    GalleriaModule,
    RouterModule.forRoot(routerConfig)
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/dev-man/Kgwetlwo-app/src/app/app.module.ts